import api from '../axios/axiosInstance';

export interface LoginResponse {
  _id: string;
  email: string;
  name: string;
  avatar?: string;
  role: {
    _id: string;
    name: string;
    permissions: string[];
    createdAt: string;
    updatedAt: string;
  };
  country: string;
  access_token: string;
  refresh_token: string;
  userPosCount: number;
  subscriptionStatus: string;
  subscriptionType: string;
  subscriptionStartDate: string;
  subscriptionEndDate: string;
  trialPeriod: number;
  userStores: {
    _id: string;
    name: string;
    nameAr: string;
    POSs: {
      ID: string;
      name: string;
      number: number;
      userId: string;
      ownerId: string;
      deviceId: string;
      deviceType: string;
      storeId: string;
    }[];
  }[];
  pin: number;
  devicePOS: string | null;
}

const login = async (data: { email: string; password: string }): Promise<LoginResponse> => {
  const response = await api.post('/users/login', data);
  return response.data;
};

export default login;
